import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

interface Props {
  campaignId: string;
}

export const useInvalidateCampaignQueries = ({ campaignId }: Props) => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ['campaigns', campaignId] });
  }, [campaignId, queryClient]);
};
